import React from "react";

/**
 * Logo oficial MontaJá — símbolo "M modular conectado" (SVG inline).
 * Props:
 *  - size: "sm" | "md" | "lg" | "xl"
 *  - inverse: true → wordmark branco (fundos escuros)
 *  - mark: true → apenas o símbolo
 *  - slogan: true → exibe "É só montar. MontaJá!"
 */
export default function LogoAtivaJa({ size = "md", inverse = false, mark = false, slogan = false, className = "" }) {
  const heights = { sm: 28, md: 40, lg: 56, xl: 72 };
  const h = heights[size] || 40;
  const textColor = inverse ? "#FFFFFF" : "#142766";
  const orange = "#FF6700";

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`} style={{ height: h }} data-testid="logo-ativaja">
      {/* SÍMBOLO — quadrado azul com M branco, pontos azul/laranja e seta laranja */}
      <svg viewBox="0 0 64 64" height={h} width={h} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="0" y="0" width="64" height="64" rx="15" fill="#142766" />
        {/* Seta laranja (canto sup. direito) */}
        <path d="M 40 16 L 51 16 Q 53.5 16 53.5 18.5 L 53.5 29" stroke={orange} strokeWidth="6" strokeLinecap="round" fill="none" />
        {/* M branco */}
        <path d="M 15 48 L 15 22 L 30 38 L 45 22 L 45 48" stroke="#FFFFFF" strokeWidth="7.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        {/* Pontos das extremidades */}
        <circle cx="15" cy="22" r="4.6" fill="#126BFF" />
        <circle cx="45" cy="22" r="4.6" fill={orange} />
      </svg>

      {/* WORDMARK */}
      {!mark && (
        <div className="flex flex-col leading-none" style={{ fontFamily: "'Manrope', sans-serif" }}>
          <span style={{ color: textColor, fontSize: h * 0.46, fontWeight: 800, letterSpacing: "-0.02em", lineHeight: 1 }}>
            Monta<span style={{ color: orange }}>Já</span>
          </span>
          {slogan && (
            <span style={{
              color: inverse ? "#B8C4E0" : "#64748B",
              fontSize: h * 0.17, fontWeight: 700, letterSpacing: "0.22em",
              marginTop: h * 0.07, lineHeight: 1, textTransform: "uppercase",
            }}>
              É só montar. MontaJá!
            </span>
          )}
        </div>
      )}
    </div>
  );
}
